import React, { PureComponent } from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, func } from 'prop-types';
import FlowPostbackStatus from '../../../../components/Flow/FlowPostbackStatus';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import Hint from '../../../../components/Hint/Hint';
import { FHTMLMessage, FMessage, ThemedFMessage } from '../../../../hoc/IntlComponents';

const GENERATE_CONVERSION_STATUS = [0, 1, 2, 3];

class FlowPostbackStatuses extends PureComponent {
    static propTypes = {
        statuses: array.isRequired,
        selected: array.isRequired,
        onStatusChange: func.isRequired,
    };

    static defaultProps = {
        statuses: [],
        selected: GENERATE_CONVERSION_STATUS,
        onStatusChange() { },
    };

    state = {
        enabled: false,
    };

    // componentWillReceiveProps(nextProps) {
    //     this.setState(() => ({
    //         enabled: nextProps.selected.length !== 0,
    //     }));
    // }

    toggleExtraStatuses = () => {
        this.setState(
            prevState => ({
                enabled: !prevState.enabled,
            }),
            () => {
                if (!this.state.enabled) {
                    this.props.onStatusChange([]);
                } else {
                    this.props.onStatusChange(GENERATE_CONVERSION_STATUS);
                }
            },
        );
    };

    handleChange = ({ target }) => {
        const id = parseInt(target.value, 10);
        const { selected } = this.props;

        if (selected.includes(id)) {
            this.props.onStatusChange(selected.filter(status => status !== id));
        } else {
            this.props.onStatusChange([...selected, id]);
            // this.setState(() => ({ enabled: true }));
        }
    };

    render() {
        const { statuses, selected } = this.props;
        const { enabled } = this.state;

        return (
            <div className="postback-statuses">
                <Row>
                    <Col lg='2'>
                        <span className='postback_status_all_wrapper'>
                            <CustomControl
                                id="postback_status_all"
                                className="custom-control-xs"
                                value="all"
                                checked={enabled}
                                onChange={this.toggleExtraStatuses}
                            >
                                <FormattedMessage
                                    id="flow.form.postback.statuses"
                                    defaultMessage="Statuses"
                                />
                            </CustomControl>
                            <Hint
                                id="postback_status_all_hint"
                                title={<FMessage id='flow.form.postback.report-statuses.hint.header' />}
                                text={<FHTMLMessage id='flow.form.postback.report-statuses.hint.body' />}
                            />
                        </span>
                    </Col>
                    <Col lg='6'>
                        <ul className="flow-postback-statuses">
                            <Row>
                                {statuses.map(({ id, title }) => (
                                    <Col lg='6' key={id}>
                                        <FlowPostbackStatus
                                            key={id}
                                            onChange={this.handleChange}
                                            label={<ThemedFMessage id={`flow.form.postback.statuses.${id}`} />}
                                            status={id}
                                            checked={selected.includes(id)}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </ul>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default FlowPostbackStatuses;
